import { ReactElement } from "react";
import { Await } from "react-router-dom";
import { BreakingNewsContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import BreakingNewsPageContent from "./BreakingNewsPageContent";

export default function BreakingNewsPage(): ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<BreakingNewsContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: BreakingNewsContext) => {
        // Load breaking news page content.
        if (kind === "static") {
          return <BreakingNewsPageContent data={data} />;
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
